import { useResetPasswordMutation } from 'api/loginApi.ts';
import { ChangeEvent, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import ForgotModalComponent from "ui/components/ForgetPassword";
import { setShowForgotPassword, setShowLogin, setShowRegister } from '../../../store/userSlice.ts';
export const ForgotPasswordModal = () => {
  const dispatch = useDispatch()
  const [forgotPassword, { data, isError, isLoading, isSuccess }] = useResetPasswordMutation()
  const [email, setEmail] = useState("")

  const FALLBACK_MESSAGE: string = "If an account matching the provided information exists, a password reset link will be sent to the associated email address. Please check your email inbox and spam folder."

  const handleBack = () => {
    dispatch(setShowLogin(true))
    dispatch(setShowForgotPassword(false))
    dispatch(setShowRegister(false))
  }

  const handleEmailChange = (e: ChangeEvent<HTMLInputElement>) => {
    setEmail(e.target.value)
  }

  const handleForgot = () => {
    forgotPassword({ email_or_username: email })
  }

  useEffect(() => {
    if (!isLoading && (isError || isSuccess)) {
      setEmail("")
    }
  }, [isError, isLoading, isSuccess]);

  return <ForgotModalComponent
    email={email}
    forgotPassword={handleForgot}
    handleChangeLoginEmail={handleEmailChange}
    handleGotoLogin={handleBack}
    isLoadingForgot={isLoading}
    bannerMessage={isSuccess && !data?.message ? FALLBACK_MESSAGE : data?.message}
    bannerMessageIsError={isError}
    container={document.getElementById('root-atarim')?.shadowRoot?.getElementById('app-wrapper')}
  />
}